// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IPublisherExtendedPropertiesSchema } from '../publisher_extended_properties/PublisherExtendedPropertiesSchema';
import type { IPublisherMediaSchema } from '../publisher_media/PublisherMediaSchema';
import type { IPhoneSchema } from '../phone/PhoneSchema';
import type { IWorkHoursSchema } from '../work_hours/WorkHoursSchema';

export interface IPublisherSchema {
  /** Расширенные данные **/
  extendedProperties: IPublisherExtendedPropertiesSchema;
  /** ID **/
  id: number;
  /** Ссылки на медиа **/
  media: IPublisherMediaSchema;
  /** Имя или название **/
  name: string;
  /** Телефоны **/
  phones: IPhoneSchema[];
  /** Ссылка на выдачу **/
  publishedOffersPageUrl?: string;
  /** Тип **/
  type?: EType;
  /** Текстовое представление типа публиканта **/
  typeLabels?: string[];
  /** Ссылка на профиль пользователя **/
  url?: string;
  /** Рабочие часы **/
  workHours?: IWorkHoursSchema;
}
export enum EType {
  /** Агентство **/
  'Agency' = 'agency',
  /** Агент **/
  'Agent' = 'agent',
  /** Банк **/
  'Bank' = 'bank',
  /** Оператор коворкингов **/
  'CoworkingOperator' = 'coworkingOperator',
  /** Государство **/
  'Government' = 'government',
  /** Крупный собственник **/
  'Landlord' = 'landlord',
  /** Торговая площадка **/
  'TradingPlatform' = 'tradingPlatform',
  /** Мелкий собсвенник **/
  'Yeoman' = 'yeoman',
}
